import React, {
  memo,
  useContext,
} from 'react';

import PropTypes from 'prop-types';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { ThemeContext } from '../contexts/Theme/themeContext';

const Theme = ({ children }) => {
  const { state: { theme } } = useContext(ThemeContext);
  return (
    <ThemeProvider theme={createMuiTheme(theme)}>
      { children }
    </ThemeProvider>
  );
};

Theme.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
};

export default memo(Theme);
